import { jwtDecode } from "jwt-decode";
import Config from "../Context/Config";

const isTokenValid = (token) => {
  try {
    const { exp } = jwtDecode(token);
    if (!exp) return false;
    const currentTime = Date.now() / 1000;
    return currentTime < exp;
  } catch (error) {
    console.error("Invalid token:", error);
    return false;
  }
};

export const checkTokenAndNavigate = (runTask,navigate) => {
  const accessToken = Config.accessToken;

  if (accessToken) {
    const isAccessValid = isTokenValid(accessToken);

    if (isAccessValid) {
      runTask();
    } 
    else {
      console.warn("Access token has expired.");
      navigate(`/?token=${Config.token}`, { replace: true });
    }
  } 
  else {
    console.warn("Required auth info missing.");
    navigate(`/?token=${Config.token}`, { replace: true });
  }
};
